<template>
  <div :class="['page-container', prefix, `${prefix}-wrap`]">
    <AffixSearch v-show="isFixed"></AffixSearch>
    <Header></Header>
    <!-- 商品显示区域 -->
    <div class="page-content full-box">
      <HomeNav></HomeNav>
      <div>
        <CategoryFloor
          v-for="(item, index) in categoryFloors"
          :key="`floor-cat${index}`"
          :floorData="item"
          :id="`floor-cat${index}`"
        ></CategoryFloor>
      </div>
    </div>

    <div
      v-show="isFixed"
      class="floor-btn-box"
    >
      <Anchor :affix="false">
        <AnchorLink
          v-for="(item, index) in categoryFloors"
          :key="index"
          :href="`#floor-cat${index}`"
          :title="item.Name"
          :scroll-offset="90"
        />
      </Anchor>
      <BackTop>
        <div class="go-top">
          <span class="icon iconfont iconpackup"></span>
          <p>顶部</p>
        </div>
      </BackTop>
    </div>

  </div>
</template>

<script>
import '@/styles/pages/home.scss';
import Header from '@/components/header/Header';
import AffixSearch from '@/components/home/AffixSearch';
import HomeNav from '@/components/home/HomeNav';
import CategoryFloor from '@/components/category/CategoryFloor';
import { mapActions } from 'vuex';
const prefix = 'page-homepage';
export default {
  name: 'HomePage',
  components: {
    AffixSearch,
    Header,
    HomeNav,
    CategoryFloor
  },
  data () {
    return {
      prefix,
      isFixed: false,
      categoryFloors: []
    };
  },
  methods: {
    ...mapActions({
      getCategoryFloors: 'getCategoryFloors'
    }),
    handleScroll () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop >= 600;
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
    this.getCategoryFloors()
      .then(result => {
        if (result.Success && result.Data) {
          this.categoryFloors = result.Data;
        }
      })
      .catch(error => {
        console.log('error:', error);
      });
  },
  mounted () {
    this.handleScroll();
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue